<template>
    <Container>
      <div class="flex-wrap flex-between align-start" style="padding:0 10px">
        <div>
      <Toolbar
        :items="tools"
        v-model="filter"
        :counts="counts"
        @on-event="handleEvent"
      >

      </Toolbar>
      <Toolbar
        :items="tools2"
        v-model="filter"
        :counts="counts"
        @on-event="handleEvent"
      >


      </Toolbar>
    </div>
      <div class="flex-wrap">
      <Button style="margin-right:5px" icon="md-add" type="primary" @click="showCreateForm">登记证书</Button>
      <Button style="margin-left:5px" icon="md-download" @click="exportExcel" />
      </div>
    </div>


      <div class="table-wrap" style="flex-grow:1;position;relative;margin:0 15px;">
        <BaseTable
          ref="table"
          :columns="columns"
          :data="items"
          :page="page"
          border
          :page-size="pagesize"
          @event="handleEvent"
          :loading="loading"
          :count="total"
        ></BaseTable>
      </div>

      <Editor
        ref="editor"
        v-model="showEditor"
        :data="current"
        :loading="loadingEditor"

        model="OA_Certification"
        @on-event="handleEvent"
      />

    </Container>
  </template>

<script>
import Container from '@/components/app/container';
import Toolbar from '@/components/app/toolbar';
import Editor from '@/components/model/editor';
import moment from 'moment';
import {cloneDeep} from 'lodash';
export default {
  routerOption: {
    as_default: true,
  },
  components: {Container, Toolbar, Editor},
  data() {
    return {
      filter: {

      },
      showEditor: false,
      loadingEditor: false,
      showFlowEditor: false,
      flowFormData: {},
      items: [],
      loading: false,
      current: {},
      formData: {},
      page: 1,
      pagesize: 20,
      total: 10,
      certTypes: [],
      counts: {

      },
      order: {
        key: 'created_by',
        order: 'desc',
      },
      deps: [],
    };
  },
  methods: {
    showCreateForm() {
      this.current = {};
      this.formData = {};
      this.showEditor = true;
    },
    Edit(item) {
      this.loadingEditor = true;
      this.showEditor = true;
      this.$api.get(`oa/certifications/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
        this.formData = cloneDeep(this.current);
        this.showEditor = true;
      }).catch((e)=>{
        this.loadingEditor = false;
        this.loadingEditorError = true;
      });
    },
    exportExcel() {
      this.$refs.table.exportExcel();
    },
    getStatusCounts() {
      this.$api.getCounts('/oa/certifications', {
        count_by: 'cert_type_id',
      }).then((res)=>{
        this.counts = Object.assign(this.counts, res.data.data);
      });
    },
    getCertType() {
      this.$api.afterLogin(()=>{
        this.$api.get(`/oa/certification-types`).then((res)=>{
          this.certTypes = res.data.data;
        });
      });
    },
    getData() {
      this.loading = true;
      this.$api.afterLogin(()=>{
        this.$api.getPaged('/oa/certifications', {
          page: this.page,
          pagesize: this.pagesize,
          order: this.order,
          filter: this.filter,
        }).then((res)=>{
          const {count, list} = res.data.data;
          list.forEach((v)=>{
            v.locked = v.project_id?true:false;
          });
          this.items = list;
          this.total = count;
          this.loading = false;
        });

        this.$api.get('/deps?q=subject').then((res)=>{
          this.deps = res.data.data;
        });
      });
    },
    createItem(model) {
      this.$api.post('/oa/certifications', model).then((res)=>{
        this.$Notice.success({title: '创建成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    updateItem(model) {
      const id = this.current.id;
      this.$api.patch(`/oa/certifications/${id}`, model).then((res)=>{
        this.$Notice.success({title: '修改成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    handleDelete(item) {
      this.Confirm(`即将删除此项目<span style="color:var(--error)">${item.type}</span>，是否继续?`, ()=>{
        this.$api.delete('/oa/certifications/'+item.id).then((res)=>{
          this.$Notice.success({title: '删除成功'});
          this.getData();
        });
      });
    },
    createFlow(task) {
      this.flowFormData = {
        target_id: task.id,

      };
      this.showFlowEditor = true;
    },
    handleEvent({type, key, value, data}) {
      const eventMap = {
        'add': this.showCreateForm,
        'search': this.getData,
        'create': this.createItem,
        'refresh': ()=>{
          this.getStatusCounts();
          this.getCertType();
          this.getData();
        },
        'update': this.updateItem,
        'tab-change': this.getData,
        'page-change': ()=>{
          this.page = data;
          this.getData();
        },
        'page-size-change': ()=>{
          this.pagesize = data;
          this.getData();
        },
        'sort': ()=>{
          if (!data || !data.key) {
            this.order = {
              key: 'created_at',
              order: 'desc',
            };
          } else {
            this.order = data;
          }
          this.getData();
        },
        'clearFilter': ()=>{
          this.filter={status: this.filter.status};
          this.getData();
        },
      };


      const eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      }
    },
  },
  computed: {
    tools() {
      return [{
        key: 'search',
        placeholder: '输入人员/证书名称',
        type: 'search',
        width: 300,
      }, {
        key: 'company_type',
        type: 'tabs',

        subs: ['监理', '咨询', '挂靠'],

      }, {
        key: 'refresh',
        icon: 'md-refresh',
        type: 'icon-button',
      }, {
        key: 'clearFilter',
        icon: 'md-close',
        type: 'icon-button',
      }];
    },
    tools2() {
      return [{
        key: 'cert_type_id',
        type: 'tabs',
        countable: true,
        multiple: true,
        subs: this.certTypes.map((v)=>({
          key: v.id,
          name: v.shortname || v.name,
        })),

      }];
    },
    columns() {
      const that = this;
      return [
        {type: 'index', width: 80, title: '序号'},
        {
          type: 'user',
          key: 'employee_id',
          title: '姓名',
          width: 120,
        },
        {key: 'type', width: 300, title: '证书名称', sortable: 'custom',
          render: (h, {row})=>{
            let tag = h('img', {attrs: {
              src: 'https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif',
            }, style: 'width:30px;height:15px;margin-left:10px;'});

            if (moment(row.created_by).isBefore(moment().subtract(3, 'days'))) {
              tag = '';
            }
            const cert = this.certTypes.find((c)=>c.id == row.cert_type_id);
            if (!cert) {
              return h('span', '-');
            }
            const name = h('div', {style: 'white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 30px;);overflow:hidden;margin-left:10px;'}, cert.name);
            return h('div', {
              class: 'flex-wrap',
              style: {
                color: 'var(--primary)',
                fontWeight: 'bold',
                textAlign: 'left',
              },
            }, [name, tag]);
          },
        },
        {
          key: 'subject',
          title: '专业',
          width: 120,
        },
        {
          key: 'cert_id',
          title: '证书编号',
          width: 160,
        },
        {
          key: 'status', width: 100, title: '证书状态', sortable: false,
          render: (h, {row})=>{
            const status = '有效';
            let statusColor = 'var(--success)';
            if (row.expiredTime) {
              if (moment().isBefore(moment(row.expired_at).subtract(3, 'months'))) {
                status == '临近过期';
                statusColor = 'var(--warning)';
              } else if (moment().isAfter(moment(row.expired_at))) {
                status == '已过期';
                statusColor = 'var(--error)';
              }
            }

            return h('div', {class: 'flex-wrap flex-center'}, [
              h('div', {style: `width:60px;padding:2px;border-radius:3px;background:${statusColor};color:#fff;border:1px solid #ddd;`,
              }, status)]);
          },
        },
        {key: 'expireTime', width: 100, title: '过期时间', sortable: 'custom',
          render: (h, {row})=>{
            return h('span', row.expired_at?moment(row.expired_at).format('YYYY-MM-DD'):'-');
          }},
        {
          key: 'accquired_at',
          title: '取证时间',
          width: 100,
          type: 'time',
          option: {
            type: 'date',
          },
        },
        {
          key: 'company_type',
          title: '归属',
          width: 100,
        },
        {type: 'user', key: 'created_by', width: 100, title: '录入人', sortable: 'custom'},
        {key: 'created_at', width: 100, title: '录入时间', sortable: 'custom',
          render: (h, {row})=>{
            return h('span', moment(row.created_at).fromNow());
          }},
        {key: 'tools', minWidth: 140, title: '操作', sortable: false,
          render: (h, {row})=>{
            const buttons = [
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.Edit(row);
              }}}, '修改'),
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.handleDelete(row);
              }}}, '删除'),
            ];
            return h('div', {class: 'flex'}, [buttons]);
          },
        },
      ];
    },
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getData();
      this.getCertType();
      this.getStatusCounts();
      this.$nextTick(()=>{
        if (this.$refs && this.$refs.table && this.$refs.table.calcTableHeight) {
          this.$refs.table.calcTableHeight();
        }
      });
    });
  },
};
</script>

  <style lange="less">
  .filter-box{
    height:50px;
  }

  .table-wrap{
    height:calc(100% - 110px);
    position: relative;
  }

  </style>
